import { RootState } from 'store/rootReducer'

import { cartGiftsAdapter } from '../cart-slice'

export const selectGifts = cartGiftsAdapter.getSelectors<RootState>(state => {
	return state.cart.gifts || cartGiftsAdapter.getInitialState()
})
